import RetentionReportList from './retention-report.list';

export default {
  list: RetentionReportList,
};
